var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "3rem",
    height: "3rem",
    viewBox: "0 0 29.995 29.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinterest_2_",
    transform: "translate(0 -0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35839",
    "data-name": "Gruppe 35839",
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47013",
    "data-name": "Pfad 47013",
    d: "M15,.008A15,15,0,0,0,8.978,28.741,13.055,13.055,0,0,1,9.236,25.3c.29-1.218,1.932-8.173,1.932-8.173a5.765,5.765,0,0,1-.479-2.372c0-2.223,1.288-3.882,2.891-3.882A2.008,2.008,0,0,1,15.6,13.121c0,1.37-.873,3.423-1.323,5.322a2.321,2.321,0,0,0,2.366,2.889c2.842,0,4.756-3.651,4.756-7.974,0-3.286-2.214-5.747-6.241-5.747a7.1,7.1,0,0,0-7.383,7.181,4.318,4.318,0,0,0,.988,2.941.729.729,0,0,1,.214.837c-.072.276-.235.941-.305,1.2a.517.517,0,0,1-.751.376c-2.1-.857-3.07-3.15-3.07-5.729,0-4.261,3.593-9.368,10.717-9.368,5.727,0,9.5,4.142,9.5,8.59,0,5.883-3.272,10.279-8.094,10.279a4.3,4.3,0,0,1-3.663-1.871s-.871,3.456-1.054,4.123a12.641,12.641,0,0,1-1.51,3.213A15,15,0,1,0,15,.008Z",
    transform: "translate(0 -0.008)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.1a9c35568de2eabbb47ea93774f2ce59.svg";
export { ForwardRef as ReactComponent };